export const SESSION_COOKIE = {
	NAME: 'sa-cookie',
	LIFESPAN_IN_DAYS: 365,
	SESSION_SEPARATOR: ',',
	KEY_VALUE_SEPARATOR: '='
};

export const CLASSES = {
	INVALID_INPUT: '.form-input--error'
};

export const ERROR_CODES = {
	REQUIRED: 'REQUIRED',
	TOO_SHORT: 'TOO_SHORT',
	TOO_LONG: 'TOO_LONG',
	TOO_LOW: 'TOO_LOW',
	TOO_HIGH: 'TOO_HIGH',
	TOO_FEW_ITEMS: 'TOO_FEW_ITEMS',
	TOO_MANY_ITEMS: 'TOO_MANY_ITEMS',
	WRONG_EMAIL: 'WRONG_EMAIL',
	WRONG_FORMAT: 'WRONG_FORMAT',
	CANNOT_BE_EMPTY: 'CANNOT_BE_EMPTY',
	NOT_ALLOWED_VALUE: 'NOT_ALLOWED_VALUE',
	INVALID_DATE: 'INVALID_DATE',
	DATE_LESS_THAN_MIN: 'DATE_LESS_THAN_MIN',
	DATE_GREATER_THAN_MAX: 'DATE_GREATER_THAN_MAX',
	FORMAT_ERROR: 'FORMAT_ERROR',
	MAX_FILE_SIZE: 'MAX_FILE_SIZE',
	MAX_TOTAL_FILE_SIZE: 'MAX_TOTAL_FILE_SIZE',
	MAX_FILE_COUNT: 'MAX_FILE_COUNT',
	FORBIDDEN_FILE_EXTENSION: 'FORBIDDEN_FILE_EXTENSION',
	FORBIDDEN_FILENAME_PATTERN: 'FORBIDDEN_FILENAME_PATTERN',
	FORBIDDEN_EMAIL_DOMAIN: 'FORBIDDEN_EMAIL_DOMAIN',
	INVALID_PHONE_NUMBER: 'INVALID_PHONE_NUMBER',
	UNKNOWN: 'UNKNOWN'
};

export const RESPONSE_ERROR_CODES_MAP = {
	'required': ERROR_CODES.REQUIRED,
	'minlength': ERROR_CODES.TOO_SHORT,
	'maxlength': ERROR_CODES.TOO_LONG,
	'min': ERROR_CODES.TOO_LOW,
	'max': ERROR_CODES.TOO_HIGH,
	'pattern': ERROR_CODES.WRONG_FORMAT,
	'max-size': ERROR_CODES.MAX_FILE_SIZE,
	'max-total-size': ERROR_CODES.MAX_TOTAL_FILE_SIZE,
	'max-file-count': ERROR_CODES.MAX_FILE_COUNT,
	'file-extension': ERROR_CODES.FORBIDDEN_FILE_EXTENSION,
	'filename-pattern': ERROR_CODES.FORBIDDEN_FILENAME_PATTERN,
	'multi-select': ERROR_CODES.REQUIRED,
	'type': ERROR_CODES.WRONG_FORMAT
};

export const AUTO_TAB_INDEX_DATA_ATTR = 'data-auto-tab-index';

export const KEYS = {
	BACKSPACE: 'Backspace'
};

export const EVENTS = {
	BLUR: 'blur',
	INPUT: 'input',
	DATE_INPUT: 'date-input',
	INPUT_TO_VALIDATE: 'input-to-validate',
	BLUR_TO_VALIDATE: 'blur-to-validate'
};

export const FILE_INPUT_STATES = {
	IS_UPLOADING: 'isUploading',
	IS_DRAG_ON: 'isDragOn',
	UPLOAD_PROGRESS: 'uploadProgress',
	UPLOADED_FILES: 'uploadedFiles'
};

export const PHONE_NUMBER_INPUT_FIELDS = {
	COUNTRY_CODE: 'countryCode',
	AREA_CODE: 'areaCode',
	PHONE_NUMBER: 'phoneNumber'
};

export const MIN_PHONE_NUMBER_LENGTH_TO_PARSE = 11;

export const FIRST_STEP = 1;

export const STEP_REF_PREFIX = 'step';

export const SESSION_META = {
	OBJECT: 'meta',
	LAST_STEP: 'lastStep'
};



// WEBPACK FOOTER //
// ../source/modules/DNFORM/DNFORM-utils/DNFORM-constants.js